export default "__VITE_ASSET__BY7kJVv1__"